import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { Mapa } from 'src/app/models/mapa-models/mapa.model';
import { CommonDataService } from '../commons/common-data.service';
import { API_URL_MAPAS } from 'src/app/app.constants';
import { Ticket } from 'src/app/models/ticket.model';

@Injectable({
  providedIn: 'root'
})
export class MapaDataService extends CommonDataService<Mapa>
{
  protected override baseEndpoint=`${API_URL_MAPAS}/mapas`;
  protected override atributoListado="";

  constructor(protected http: HttpClient) {
    super(http)
   }


  public procesarTicket(idTicket: number) {
    return this.http.put<any>(`${API_URL_MAPAS}/tickets/procesar/${idTicket}`, null, {
      headers: this.headers
    });
  }  

  public liberarTicket(idTicket: number) {
    return this.http.put<any>(`${API_URL_MAPAS}/tickets/liberar/${idTicket}`, null, {
      headers: this.headers
    });
  }  

  public cambiarEstados(tickets: Ticket[]) {
    const ticketsIds : number[] = []
    tickets.forEach(t=> ticketsIds.push(t.id))
    return this.http.put<{ ticket: Ticket[] }>(`${API_URL_MAPAS}/tickets/estados`, ticketsIds, {
      headers: this.headers
    }).pipe(
      map(response => response.ticket)
    );
  } 

  
  
}